
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      sid: null as any,
      detail: {} as any,
      printLoading: null as any,
      groupMap: [] as any[],
    };
  },
  async mounted() {
    this.sid = this.$route.query.sid;
    await this.getDetail();
  },
  methods: {
    /**
     * 将 kpiDetails 按 kpiGroupName 分组，返回 {name:'分组名', items:[明细]} 数组结构
     * @param {Array} kpiDetails 原始明细数组
     * @returns {Array<{name:string, items:Array}>}
     */
    groupKpiByGroupName(kpiDetails: any[]) {
      const groupMap = {} as any;
      if (!Array.isArray(kpiDetails)) return [];

      kpiDetails.forEach((item) => {
        const groupName = item.kpiGroupName || "未分组";
        if (!groupMap[groupName]) {
          groupMap[groupName] = [];
        }
        groupMap[groupName].push(item);
      });

      // 转换成 name + items 结构
      return Object.keys(groupMap).map((groupName) => ({
        name: groupName,
        items: groupMap[groupName],
      }));
    },
    async getDetail() {
      this.detail = await HttpUtil.XCHttpPost(Urls.GetKpiDetail, this.sid, true, false);
      const ret = this.groupKpiByGroupName(this.detail.kpiDetails);
      this.groupMap = ret;
    },
    handlePrint() {
      // 防止重复点击
      if (this.printLoading) {
        return;
      }
      this.printLoading = true;

      // 滚动至页面顶部，避免打印缺少标题
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });

      // 等待滚动生效后唤起打印
      setTimeout(() => {
        try {
          window.print();
        } catch (err) {
          console.error("打印调用异常：", err);
          this.$message?.error("当前浏览器不支持打印功能");
        }

        // 延时关闭loading，给打印弹窗弹出留出时间
        setTimeout(() => {
          this.printLoading = false;
        }, 800);
      }, 50);
    },
  },
});
